import { useEffect, useState } from "react";
import { Tag, Check, Loader2, AlertTriangle } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { TRY } from "@/lib/format";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { MODES, MODE_LABEL } from "@/lib/pos";
import { receiptBelgeNo } from "@/lib/receipt";

// Tamamlanmış fişin satış modunu değiştir: kalem fiyatları yeni modun iskonto kuralına göre yeniden hesaplanır
export function ChangeModeDialog({ sale, onClose, onDone }) {
  const [mode, setMode] = useState("genel");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (sale) setMode(sale.mode || "genel"); }, [sale]);
  const cur = sale?.mode || "genel";
  const apply = async () => {
    if (mode === cur) return onClose();
    setBusy(true);
    try {
      const { data } = await api.post(`/quick-sales/${sale.id}/change-mode`, { mode });
      toast.success(`Satış modu ${MODE_LABEL[mode]} olarak güncellendi · yeni toplam ${TRY(data.grand_total)}`);
      onDone(data);
    } catch (e) { toast.error(apiError(e)); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open={!!sale} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-[96vw] sm:max-w-md" data-testid="qs-changemode-dialog">
        <DialogHeader>
          <DialogTitle className="font-head text-xl flex items-center gap-2"><Tag className="h-5 w-5 text-primary" />Satış Modunu Değiştir</DialogTitle>
          <DialogDescription>{sale ? `${receiptBelgeNo(sale)} · ${TRY(sale.grand_total)} · şu an ${MODE_LABEL[cur]}` : ""}</DialogDescription>
        </DialogHeader>
        <div className="space-y-1.5" data-testid="qs-changemode-options">
          {MODES.map(([val, lbl, desc]) => {
            const on = mode === val;
            return (
              <button key={val} type="button" onClick={() => setMode(val)} data-testid={`qs-changemode-${val}`}
                className={cn("w-full flex items-center justify-between gap-3 rounded-xl border-2 px-4 py-3 text-left transition-all active:scale-[0.99]", on ? "border-primary bg-primary/5" : "border-border hover:border-primary/40")}>
                <div><div className="font-bold text-sm">{lbl}{val === cur && <span className="ml-2 text-[10px] font-bold uppercase tracking-wider text-muted-foreground">mevcut</span>}</div><div className="text-[11px] text-muted-foreground">{desc}</div></div>
                {on && <Check className="h-4 w-4 text-primary shrink-0" />}
              </button>
            );
          })}
        </div>
        <div className="flex items-start gap-2 rounded-lg border border-amber-500/40 bg-amber-500/10 px-3 py-2 text-[11.5px] text-amber-800 dark:text-amber-200 leading-snug" data-testid="qs-changemode-warn">
          <AlertTriangle className="h-4 w-4 shrink-0 mt-px" />
          <span>Her kalemin birim fiyatı seçilen modun <b>iskonto kuralına göre yeniden hesaplanır</b>; fiş toplamı, KDV ve ödeme tutarı güncellenir. Cariye aktarılmış fişte defter kaydı da yenilenir.</span>
        </div>
        <div className="flex justify-end gap-2 pt-1">
          <Button variant="outline" onClick={onClose} data-testid="qs-changemode-cancel">Vazgeç</Button>
          <Button onClick={apply} disabled={busy || mode === cur} data-testid="qs-changemode-apply">{busy ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : <Check className="h-4 w-4 mr-1.5" />}Yeniden Hesapla & Uygula</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
